<template>
    <div class="archived-order-show order-detail-v1 dlm-admin-theme" data-testid="archived-order-island">
        <div class="alert alert-warning order-detail-v1__banner" role="status">
            <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
            {{ label('preview_banner', 'Ordine in archivio storicizzazione — sola lettura fino al recupero.') }}
        </div>

        <div class="order-detail-v1__header-stripe">
            <div class="row">
                <div class="col-md-6">
                    <div class="order-detail-v1__header-lead">
                        <h1 class="order-detail-v1__header-title">
                            {{ header.archive_num }}
                            <span class="label label-portal text-uppercase">{{ portalLabel }}</span>
                            <span class="label label-archive"><i class="fa fa-archive"></i> Archivio</span>
                        </h1>
                        <div class="order-detail-v1__header-buttons">
                            <a class="btn btn-show-back" :href="payload.routes.index">
                                <i class="fa fa-arrow-left" aria-hidden="true"></i> {{ label('back', 'Indietro') }}
                            </a>
                            <button
                                type="button"
                                class="btn btn-primary"
                                data-testid="archived-order-restore"
                                :disabled="restoreDisabled"
                                @click="onRestoreClick"
                            >
                                <i class="fa fa-rotate-left"></i>
                                {{ restoring ? '…' : label('restore', 'Recupera') }}
                            </button>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <dl class="order-detail-v1__header-meta row">
                        <div class="col-sm-6 col-md-3">
                            <dt>Entity</dt>
                            <dd>{{ header.entity_id ?? '—' }}</dd>
                        </div>
                        <div class="col-sm-6 col-md-3">
                            <dt>IGU prenotazione</dt>
                            <dd><code>{{ header.igu_prenotazione || '—' }}</code></dd>
                        </div>
                        <div class="col-sm-6 col-md-3">
                            <dt>{{ label('live_num_prenotazione', 'Nº prenotazione ordine attivo') }}</dt>
                            <dd>{{ header.live_suffix ?? '—' }}</dd>
                        </div>
                        <div class="col-sm-6 col-md-3">
                            <dt>Prenotato il</dt>
                            <dd>{{ header.data_prenotazione_formatted || header.data_prenotazione || '—' }}</dd>
                        </div>
                    </dl>
                </div>
            </div>
        </div>

        <div class="panel panel-default archived-order-show__restore-plan">
            <div class="panel-heading panel-heading--with-badge">
                <h4>{{ label('restore_plan', 'Piano di recupero') }}</h4>
                <span class="archived-order-show__plan-badge" :class="planLabelClass">{{ payload.plan?.status_label }}</span>
            </div>
            <div class="panel-body no-padding">
                <dl class="archived-order-show__plan-fields">
                    <div>
                        <dt>Strategia numero</dt>
                        <dd>{{ payload.plan?.number_strategy_label || '—' }}</dd>
                    </div>
                    <div>
                        <dt>{{ label('live_num_prenotazione', 'Nº prenotazione ordine attivo') }}</dt>
                        <dd>{{ payload.plan?.live_suffix ?? '—' }}</dd>
                    </div>
                    <div>
                        <dt>Righe da ripristinare</dt>
                        <dd>{{ payload.plan?.rows ?? 0 }}</dd>
                    </div>
                    <div>
                        <dt>Prenotazioni da ripristinare</dt>
                        <dd>{{ payload.plan?.prenotazioni ?? 0 }}</dd>
                    </div>
                    <div>
                        <dt>Conferma nuovo numero</dt>
                        <dd>{{ payload.plan?.requires_confirm_new_number ? 'Richiesta' : 'No' }}</dd>
                    </div>
                    <div>
                        <dt>CodiceRiga in conflitto</dt>
                        <dd>{{ payload.plan?.clashing_codice_riga || '—' }}</dd>
                    </div>
                </dl>
                <p v-if="allocateNewHint" class="archived-order-show__plan-hint">
                    <i class="fa fa-exclamation-triangle"></i> {{ allocateNewHint }}
                </p>
            </div>
        </div>

        <div class="panel panel-default">
            <div class="panel-heading">
                <h4>{{ label('summary', 'Riepilogo ordine archiviato') }}</h4>
            </div>
            <div class="panel-body no-padding">
                <dl class="order-detail-v1-field-grid">
                    <div class="order-detail-v1-field-grid__cell">
                        <dt>Nominativo</dt>
                        <dd>{{ header.nominativo?.trim() || '—' }}</dd>
                    </div>
                    <div class="order-detail-v1-field-grid__cell">
                        <dt>Email</dt>
                        <dd>{{ header.email || '—' }}</dd>
                    </div>
                    <div class="order-detail-v1-field-grid__cell">
                        <dt>Importo pagato</dt>
                        <dd>{{ summaryAmountPaid }}</dd>
                    </div>
                    <div class="order-detail-v1-field-grid__cell">
                        <dt>Pagamento</dt>
                        <dd>{{ summary.payment_description || header.payment_description || '—' }}</dd>
                    </div>
                    <div class="order-detail-v1-field-grid__cell">
                        <dt>Coupon</dt>
                        <dd>{{ summary.coupon || header.coupon || 'Nessuno' }}</dd>
                    </div>
                    <div class="order-detail-v1-field-grid__cell">
                        <dt>Reso</dt>
                        <dd>{{ summaryResoLabel }}</dd>
                    </div>
                    <div class="order-detail-v1-field-grid__cell">
                        <dt>Da fatturare</dt>
                        <dd>{{ invoiceRequestedLabel }}</dd>
                    </div>
                    <div class="order-detail-v1-field-grid__cell">
                        <dt>Note</dt>
                        <dd>{{ summary.note || header.note || '—' }}</dd>
                    </div>
                </dl>
            </div>
        </div>

        <div class="row">
            <div class="col-md-6">
                <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4>{{ label('billing', 'Fatturazione (archivio testata)') }}</h4>
                    </div>
                    <div class="panel-body">
                        <address class="archived-order-show__address">
                            <strong>{{ billingAddress.name || '—' }}</strong><br>
                            {{ billingAddress.street || '—' }}<br>
                            {{ billingAddress.zip || '' }} {{ billingAddress.city || '—' }}
                            ({{ billingAddress.province || '—' }}) · {{ billingAddress.country_code || '—' }}<br>
                            <span class="text-muted">{{ billingAddress.phone || '—' }}</span>
                        </address>
                        <h5 class="archived-order-show__fiscal-title">{{ label('fiscal', 'Dati fiscali') }}</h5>
                        <dl class="order-detail-v1-field-grid">
                            <div class="order-detail-v1-field-grid__cell">
                                <dt>Codice fiscale</dt>
                                <dd>{{ billingAddress.fiscal_code || '—' }}</dd>
                            </div>
                            <div class="order-detail-v1-field-grid__cell">
                                <dt>Partita IVA</dt>
                                <dd>{{ billingAddress.vat_number || '—' }}</dd>
                            </div>
                            <div class="order-detail-v1-field-grid__cell">
                                <dt>Codice SDI</dt>
                                <dd>{{ billingAddress.sdi_code || '—' }}</dd>
                            </div>
                        </dl>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="panel panel-default">
                    <div class="panel-heading">
                        <h4>{{ label('shipping', 'Spedizione (archivio testata)') }}</h4>
                    </div>
                    <div class="panel-body">
                        <address class="archived-order-show__address">
                            <strong>{{ shippingAddress.name || '—' }}</strong><br>
                            {{ shippingAddress.street || '—' }}<br>
                            {{ shippingAddress.zip || '' }} {{ shippingAddress.city || '—' }}
                            ({{ shippingAddress.province || '—' }}) · {{ shippingAddress.country_code || '—' }}<br>
                            <span class="text-muted">{{ shippingAddress.phone || '—' }}</span>
                        </address>
                    </div>
                </div>
            </div>
        </div>

        <div class="archived-order-show__linked-widgets">
            <div
                v-for="widget in linkedArchiveWidgets"
                :key="widget.table_name"
                class="panel panel-default archived-order-show__linked-widget"
            >
                <div class="panel-heading panel-heading--with-badge">
                    <h4>{{ widget.table_name }}</h4>
                    <span class="badge">{{ widget.count }}</span>
                </div>
                <div class="panel-body no-padding">
                    <p v-if="widget.count === 0" class="archived-order-show__linked-widget-empty">
                        Nessun record
                    </p>
                    <dl v-else class="archived-order-show__linked-widget-fields">
                        <div v-for="field in widget.fields" :key="field.label">
                            <dt>{{ field.label }}</dt>
                            <dd>{{ formatWidgetValue(field.value) }}</dd>
                        </div>
                    </dl>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import './island-styles.css';

export default {
    name: 'ArchivedOrderIsland',
    props: {
        initialPayload: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            payload: this.initialPayload,
            restoring: false,
        };
    },
    computed: {
        header() {
            return this.payload.header ?? {};
        },
        summary() {
            return this.payload.summary ?? {};
        },
        billingAddress() {
            return this.payload.billing_address ?? {};
        },
        shippingAddress() {
            return this.payload.shipping_address ?? {};
        },
        linkedArchiveWidgets() {
            return this.payload.linked_archive_widgets ?? [];
        },
        summaryAmountPaid() {
            if (this.summary.amount_paid_formatted) {
                return this.summary.amount_paid_formatted;
            }

            return this.amountPaid;
        },
        summaryResoLabel() {
            if (this.summary.reso === true || this.header.reso === true) {
                return 'Sì';
            }
            if (this.summary.reso === false || this.header.reso === false) {
                return 'No';
            }

            return '—';
        },
        invoiceRequestedLabel() {
            if (this.billingAddress.invoice_requested || this.header.da_fatturare === '1') {
                return 'Sì';
            }

            return 'No';
        },
        portalLabel() {
            const p = this.header.portale;
            if (!p || String(p).trim() === '') {
                return 'dlm';
            }

            return String(p).toLowerCase();
        },
        planLabelClass() {
            return this.payload.plan?.can_restore ? 'is-ready' : 'is-blocked';
        },
        restoreDisabled() {
            return this.restoring
                || !this.payload.plan?.can_restore
                || !this.payload.permissions?.can_restore;
        },
        amountPaid() {
            const raw = this.header.acconto_versato;
            if (raw === null || raw === undefined || raw === '') {
                return '—';
            }
            const num = Number(String(raw).replace(',', '.'));
            if (Number.isNaN(num)) {
                return raw;
            }

            return new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(num);
        },
        allocateNewHint() {
            if (this.payload.plan?.allocate_new_hint) {
                return this.payload.plan.allocate_new_hint;
            }

            if (!this.payload.plan?.can_restore || !this.payload.plan?.requires_confirm_new_number) {
                return null;
            }

            const suffix = this.payload.plan.live_suffix ?? '—';

            return `Il numero ${suffix} è già occupato da un altro ordine live: al recupero verrà assegnato un nuovo numPrenotazione.`;
        },
    },
    methods: {
        label(key, fallback) {
            return this.payload.labels?.[key] ?? fallback;
        },
        formatWidgetValue(value) {
            if (value === null || value === undefined || value === '') {
                return '—';
            }

            return String(value);
        },
        swalConfirmed(result) {
            return result && (result.isConfirmed === true || result.value === true);
        },
        async onRestoreClick() {
            if (!this.payload.plan?.can_restore || !this.payload.permissions?.can_restore) {
                return;
            }

            const plan = this.payload.plan;
            let confirmNewNumber = false;

            if (plan.requires_confirm_new_number) {
                const hint = this.allocateNewHint || 'Continuare con un nuovo numPrenotazione?';
                const swal = await this.confirmSwal(
                    `${this.label('restore', 'Recupera')} ordine ${this.header.archive_num}?`,
                    hint,
                    'Conferma e recupera',
                );
                if (!this.swalConfirmed(swal)) {
                    return;
                }
                confirmNewNumber = true;
            } else {
                const swal = await this.confirmSwal(
                    'Recuperare l\'ordine?',
                    'L\'ordine verrà copiato nelle tabelle live. L\'archivio resta invariato.',
                    'Recupera',
                );
                if (!this.swalConfirmed(swal)) {
                    return;
                }
            }

            this.restoring = true;
            try {
                const body = confirmNewNumber ? { confirm_new_number: 1 } : {};
                const response = await window.axios.post(this.payload.routes.restore, body);
                if (response.data?.redirect) {
                    window.location.href = response.data.redirect;

                    return;
                }
                if (window.Swal) {
                    await window.Swal.fire('OK', response.data?.message || 'Ordine recuperato.', 'success');
                }
            } catch (error) {
                const message = error.response?.data?.message
                    || Object.values(error.response?.data?.errors || {}).flat().join(' ')
                    || 'Recupero non riuscito.';
                if (window.Swal) {
                    await window.Swal.fire('Errore', message, 'error');
                }
            } finally {
                this.restoring = false;
            }
        },
        confirmSwal(title, text, confirmButtonText) {
            if (!window.Swal) {
                return Promise.resolve({ isConfirmed: window.confirm(`${title}\n\n${text}`) });
            }

            return window.Swal.fire({
                title,
                text,
                icon: 'question',
                showCancelButton: true,
                confirmButtonText,
                cancelButtonText: 'Annulla',
            });
        },
    },
};
</script>
